module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.b38ef310.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/styles/icons/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.woff?d7yf1v
 ** module id = 1609
 ** module chunks = 0
 **/